import React, { useRef } from 'react';
import { Delete } from 'lucide-react';
import './NumberPad.css';

// On-screen number keys for tablets and phones.
//
// iPad and Android hide their own keyboard while a Bluetooth barcode scanner is connected
// (the scanner counts as a hardware keyboard), so quantity fields can't be typed into
// there. This pad always works. The first key press replaces what the field showed
// (e.g. the default "1"); later presses add digits.
//
//   <NumberPad value={text} onChange={setText} maxLength={6} />
const NumberPad = ({ value, onChange, maxLength = 6, disabled = false, label = 'Number keys' }) => {
  const fresh = useRef(true);
  const press = (key) => {
    const current = fresh.current ? '' : String(value ?? '');
    fresh.current = false;
    if (key === 'back') onChange(String(value ?? '').slice(0, -1));
    else if (key === 'clear') onChange('');
    else if (current.length < maxLength) onChange((current === '0' ? '' : current) + key);
  };
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'clear', '0', 'back'];
  return (
    <div className="num-pad" role="group" aria-label={label}>
      {keys.map((k) => (
        <button
          key={k}
          type="button"
          className={`num-pad-key ${k.length > 1 ? 'num-pad-fn' : ''}`}
          onClick={() => press(k)}
          disabled={disabled}
          aria-label={k === 'back' ? 'Delete last digit' : k === 'clear' ? 'Clear' : k}
        >
          {k === 'back' ? <Delete size={24} aria-hidden="true" /> : k === 'clear' ? 'C' : k}
        </button>
      ))}
    </div>
  );
};

export default NumberPad;
